
import { ref, watchEffect } from "vue";
import { useRouter } from 'vue-router'
export default {
  props: {
    item: {//当前单个筛选
      type: Object,
      default: {},
    },
    skuSelected: { //传递选中数据
      type: Function,
      default: () => { },
    },
    sepc_list_key: { //点击当前索引
      type: Number,
    },
    sku: { //所有的筛选
      type: Array,
      default: [],
    },
    good: { //详情信息
      type: Object,
    },
    pitch_image: { //默认展示图片
      type: Function,
    },
    noJump: {
      type: Boolean,
      default: false
    },


  },
  setup(props: any, { emit }: any) {
    let active = ref<any>(-1);
    let colorIndex: any = ref([]);
    let colorValue: any = ref([]);
    let router = useRouter()
    //选择商品
    let spec_fn = (i: number, item: any) => {
      active.value = i; //选中颜色
      let redirect = 1;
      colorIndex.value[props.sku[props.sepc_list_key].spec_id] =
        item.spec_value_id;
      for (let i in props.sku) {
        if (i > props.sepc_list_key) {
          redirect = 0;
          if (props.good.spec_list_to_goods_id != "") {
            var redirectKey = "";
            for (var s in colorIndex.value) {
              redirectKey = redirectKey + "|" + colorIndex.value[s];
            }
            redirectKey = redirectKey.slice(1);
            if (redirectKey.indexOf("|")) {
              let redirect_arr: any = redirectKey.split("|");
              redirect_arr = redirect_arr.sort(function (a: number, b: number) {
                return a - b;
              });
              redirectKey = redirect_arr.join("|");
            }
            if (props.good.spec_list_to_goods_id[redirectKey] != "") {
              if (!props.noJump) {
                router.push({
                  name: 'goods',
                  params: {
                    id: props.good.spec_list_to_goods_id[redirectKey]
                  }
                })
              }
              emit(
                "skuSelected",
                props.good.spec_list_to_goods_id[redirectKey]
              );
            }
          }
        }
      }
      if (redirect == 1) {
        if (props.good.spec_list_to_goods_id != "") {
          var redirectKey = "";
          for (var s in colorIndex.value) {
            redirectKey = redirectKey + "|" + colorIndex.value[s];
          }
          redirectKey = redirectKey.slice(1);
          if (redirectKey.indexOf("|")) {
            let redirect_arr: any = redirectKey.split("|");
            redirect_arr = redirect_arr.sort(function (a: number, b: number) {
              return a - b;
            });
            redirectKey = redirect_arr.join("|");
          }
          if (props.good.spec_list_to_goods_id[redirectKey] != "") {
            emit("skuSelected", props.good.spec_list_to_goods_id[redirectKey]);
            if (!props.noJump) {
              router.push({
                name: 'goods',
                params: {
                  id: props.good.spec_list_to_goods_id[redirectKey]
                }
              })
            }

          }
        }
      }
    };

    watchEffect(() => {
      //页面加载找到默认选中的数据
      if (props.sku != "") {
        for (var i in props.sku) {
          for (var n in props.sku[i].spec_value) {
            if (props.sku[i].spec_value[n].spec_value_select == true) {
              colorIndex.value[props.sku[i].spec_id] =
                props.sku[i].spec_value[n].spec_value_id;
              colorValue.value.push(props.sku[i].spec_value[n].spec_value_name)
            }
          }
        }
      }
      if (props.item != "") {
        // props.item.spec_value.forEach((ele: any, index: number) => {
        //   props.good.albums.forEach((i: any, inx: number) => {
        //     if (i.color_id === ele.spec_value_id && i.is_default === 1) {
        //       if (ele.spec_value_select === true) {             
        //         emit("pitch_image", i.images.XL);
        //       }
        //     }
        //   });
        // });
        console.log(' props.good.images.XL', props.good.images.XL);

        emit("pitch_image", props.good.images.XL);
      }
    });
    return {
      active,
      spec_fn,
      colorIndex
    };
  },
};
